import { Routes } from '@angular/router';
import { AllTreatiesComponent } from './all-treaties/all-treaties.component';
import { NewTreatyComponent } from './new-treaty/new-treaty.component';
import { TreatyCasualtyDetailComponent } from './treaty-casualty-detail/treaty-casualty-detail.component';
import { TreatyPropertyDetailComponent } from './treaty-property-detail/treaty-property-detail.component';

export const treatyRoutes: Routes = [
  { path: 'treaty-assessments', component: AllTreatiesComponent },
  { path: 'treaty-assessments/new', component: NewTreatyComponent },
  { path: 'treaty-assessments/detail/casualty/:treatyId', component: TreatyCasualtyDetailComponent },
  { path: 'treaty-assessments/detail/property/:treatyId', component: TreatyPropertyDetailComponent },
];
